import SOUNDS from 'sounds'

export const SOUNDS_PLAY = 'sounds/PLAY_SOUND'
export const SOUND_STATE = 'sounds/SOUND_STATE'

function playSound(soundId) {
    const webToClient = {
        handler: 'playSound',
        params: { soundId },
    }

    return {
        type: SOUNDS_PLAY,
        payload: {},
        meta: { webToClient },
    }
}

function sendSoundState(stateName, stateValue) {
    const webToClient = {
        handler: 'sendSoundState',
        params: { stateName, stateValue },
    }
    return {
        type: SOUND_STATE,
        payload: {},
        meta: { webToClient },
    }
}

// Sound events
export function playHoverSound() {
    return playSound(SOUNDS.HOVER)
}

export function playCancelClickSound() {
    return playSound(SOUNDS.CANCEL_CLICK)
}

export function playClickSound() {
    return playSound(SOUNDS.CLICK)
}

export function playButtonClickSound() {
    return playSound(SOUNDS.BUTTON_CLICK)
}

export function playBuildingClickSound() {
    return playSound(SOUNDS.BUILDING_CLICK)
}

export function playSelectClickSound() {
    return playSound(SOUNDS.SELECT_CLICK)
}

export function playTabClickSound() {
    return playSound(SOUNDS.TAB_CLICK)
}

export function playSelectBattleClickSound() {
    return playSound(SOUNDS.SELECT_BATTLE_CLICK)
}

export function playCarouselClickSound() {
    return playSound(SOUNDS.CAROUSEL_CLICK)
}

export function playCarouselHoverSound() {
    return playSound(SOUNDS.CAROUSEL_HOVER)
}

export function playOneReserveProduceSuccessSound() {
    return playSound(SOUNDS.RESERVE_PRODUCE_SUCCESS)
}

export function playEnterMainCardSound() {
    return playSound(SOUNDS.MAIN_CARD_ENTER)
}

export function playExitMainCardSound() {
    return playSound(SOUNDS.MAIN_CARD_EXIT)
}

export function playEnterAnnouncementSound() {
    return playSound(SOUNDS.ANNOUNCEMENT_ENTER)
}

export function playExitAnnouncementSound() {
    return playSound(SOUNDS.ANNOUNCEMENT_EXIT)
}

export function playEnterStrongholdSound() {
    return playSound(SOUNDS.STRONGHOLD_ENTER)
}

export function playExitStrongholdSound() {
    return playSound(SOUNDS.STRONGHOLD_EXIT)
}

export function playEnterGlobalMapSound() {
    return playSound(SOUNDS.GLOBAL_MAP_ENTER)
}

export function playExitGlobalMapSound() {
    return playSound(SOUNDS.GLOBAL_MAP_EXIT)
}

export function playEnterClansWinnerRewardSound() {
    return playSound(SOUNDS.CLANS_WINNER_REWARD_ENTER)
}

export function playExitClansWinnerRewardSound() {
    return playSound(SOUNDS.CLANS_WINNER_REWARD_EXIT)
}

export function playEnterClansBattlesGlobalMapSound() {
    return playSound(SOUNDS.CLANS_BATTLES_GLOBAL_MAP_ENTER)
}

export function playExitClansBattlesGlobalMapSound() {
    return playSound(SOUNDS.CLANS_BATTLES_GLOBAL_MAP_EXIT)
}

export function playClansWinnerRewardMakeBet() {
    return playSound(SOUNDS.CLANS_WINNER_REWARD_MAKE_BET)
}

export function playCongratulationClanJoiningSound() {
    return playSound(SOUNDS.CONGRATULATION_CLAN_JOINING)
}

// Sound states
export function sendEnterLandingSoundState() {
    return sendSoundState(SOUNDS.LANDING_STATE.name, SOUNDS.LANDING_STATE.enterLanding)
}

export function sendEnterMainCardSoundState() {
    return sendSoundState(SOUNDS.LANDING_STATE.name, SOUNDS.LANDING_STATE.enterMainCard)
}

export function sendEnterStrongholdSoundState() {
    return sendSoundState(SOUNDS.LANDING_STATE.name, SOUNDS.LANDING_STATE.enterStronghold)
}

export function sendEnterGlobalMapSoundState() {
    return sendSoundState(SOUNDS.LANDING_STATE.name, SOUNDS.LANDING_STATE.enterGlobalMap)
}

export function sendEnterAnnouncementsSoundState() {
    return sendSoundState(SOUNDS.LANDING_STATE.name, SOUNDS.LANDING_STATE.enterAnnouncements)
}



// WEBPACK FOOTER //
// ./state/actions/sounds.js